const search = () => {
	// Searchpage functionality
	if (window.location.href.indexOf('search') > -1) {
		return;
	}
	const searchNode = $('.searchNode');
	const searchBar = $('.searchBarRegular');
	const searchBarClose = $('.searchBar__close');
	const searchBarInput = $('.searchBar__input');

	searchNode.on('click focus', function () {
		searchBar.addClass('searchBar--show');
		searchBarInput.focus();
	});
	searchBarClose.on('click', function () {
		searchBar.removeClass('searchBar--show');
	});
	searchBarClose.on('keydown', function (e) {
		if (e.key === 'Enter' || e.key === 'Return') {
			searchBar.removeClass('searchBar--show');
		}
	});
	$(document).on('focusout', function (event) {
		let focusedElement = $(event.target);
		if (
			!searchNode.is(focusedElement) &&
			!searchBar.is(focusedElement) &&
			!searchBarClose.is(focusedElement) &&
			!searchBarInput.is(focusedElement) &&
			!$.contains(searchNode[0], focusedElement[0]) &&
			!$.contains(searchBar[0], focusedElement[0]) &&
			!$.contains(searchBarClose[0], focusedElement[0]) &&
			!$.contains(searchBarInput[0], focusedElement[0])
		) {
			searchBar.removeClass('searchBar--show');
			// Your logic when focus is outside these elements
		} else {
			return;
		}
	});

	if ($('.searchPage')) {
		const searchClear = $('#searchPageClear');
		const searchInput = $('#searchPageInput');
		searchClear.on('click', function () {
			searchInput.val('');
			searchInput.attr('placeholder', '');
			searchInput.focus();
		});
	}
};

export default search;
